import React from 'react';
import { PropTypes } from 'prop-types';

import YearSlider from './YearSlider';
import ResultsTable from './ResultsTable';
import CompareTiles from './CompareTiles';
import './results.css';
import '../../../../grid.css';
import CASHPIE from './Graphs/CASHPIE';
import CAPPIE from './Graphs/CAPPIE';
import LOANPIE from './Graphs/LOANPIE';
import PPAPIE from './Graphs/PPAPIE';
import KWHPIE from './Graphs/KWHPIE';
import OBSPIE from './Graphs/OBSPIE';
import CashPoints from './CashPoints';
import CapPoints from './CapPoints';
import ESSPoints from './ESSPoints';
import LoanPoints from './LoanPoints';
import BreakDownTile from './BreakDownTile';
import SalesLogic from './SalesLogic';
import MonthlyLoan from './MonthlyLoan';
import { DonutContainer, DataContainer, BreakdownContainer, Container } from './styles';

const Results = (props) => {
    const { selectedFinancing } = props;

    return (
        <Container>
            <div>
                {selectedFinancing === 2 && <MonthlyLoan />}
                {selectedFinancing === 2 && <LoanPoints />}
                {selectedFinancing === 4 && <CashPoints />}
                {selectedFinancing === 5 && <CapPoints />}
                {selectedFinancing === 6 && <ESSPoints />}
            </div>
            {selectedFinancing < 6 ? (
                <React.Fragment>
                    {selectedFinancing > 0 && (
                        <React.Fragment>
                            <DataContainer>
                                <BreakdownContainer>
                                    <BreakDownTile />
                                </BreakdownContainer>
                                <DonutContainer>
                                    {selectedFinancing >= 1 && <KWHPIE />}
                                    {selectedFinancing === 1 && <PPAPIE />}
                                    {selectedFinancing === 2 && <LOANPIE />}
                                    {selectedFinancing === 3 && <OBSPIE />}
                                    {selectedFinancing === 4 && <CASHPIE />}
                                    {selectedFinancing === 5 && <CAPPIE />}
                                </DonutContainer>
                            </DataContainer>
                            <YearSlider />
                        </React.Fragment>
                    )}

                    {selectedFinancing > 0 && (
                        <ResultsTable className="resultsTable" />
                    )}

                    {selectedFinancing === 0 && <SalesLogic />}
                </React.Fragment>
            ) :
                null
            }
            {selectedFinancing === 7 ?
                <CompareTiles />
                : null }
        </Container>
    );
};
Results.propTypes = {
    selectedFinancing: PropTypes.number.isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Results.js